// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperClaimedToast-cls1_IxT","cls2":"PaperClaimedToast-cls2_FPM PaperClaimedToast-cls1_IxT"};